import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { WhatsAppFirstNotice } from "@/components/booking/whatsapp-first-notice";

export const Route = createFileRoute("/_public/book")({
  component: BookLayout,
});

/** The wizard (/book/) is client-only; the notice above it is server-rendered here. */
function BookLayout() {
  const pathname = useLocation({ select: (l) => l.pathname });
  const isIndex = pathname === "/book" || pathname === "/book/";
  return (
    <>
      {isIndex && <WhatsAppFirstNotice />}
      <Outlet />
    </>
  );
}
